export default __webpack_public_path__ + "static/keyto_logo-db4cc5cd91325ddbc385cb4ed6facc1b.png";